import { useEffect, useRef, useState } from "react";
import { useSyncContext } from "../context/OfflineProvider";
import { phaseShowsPendingHint } from "../syncState";
import {
  syncPhaseHint,
  syncPhaseLabel,
  syncPhaseTone,
} from "../syncUtils";

const SYNCED_FLASH_MS = 2500;

/**
 * Reusable sync status for presentation components (no direct Firestore access).
 */
export function useSyncStatus() {
  const { phase, hasPendingWrites } = useSyncContext();
  const prevPhase = useRef(phase);
  const [showSyncedFlash, setShowSyncedFlash] = useState(false);

  useEffect(() => {
    const previous = prevPhase.current;
    prevPhase.current = phase;
    if (
      phase === "live" &&
      (previous === "saving" ||
        previous === "waiting_to_sync" ||
        previous === "connecting")
    ) {
      setShowSyncedFlash(true);
      const timer = window.setTimeout(() => setShowSyncedFlash(false), SYNCED_FLASH_MS);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [phase]);

  const displayPhase = showSyncedFlash ? "synced" : phase;
  const minimal = displayPhase === "live";
  const label = syncPhaseLabel(displayPhase);
  const hint = phaseShowsPendingHint(displayPhase)
    ? syncPhaseHint(displayPhase)
    : "";
  const tone = syncPhaseTone(displayPhase);

  return {
    phase,
    displayPhase,
    minimal,
    label,
    hint,
    tone,
    hasPendingWrites,
  };
}
